import { createSelector } from 'reselect'

const createCardStatusSelector = (cardIdSelector) => createSelector<any, any, any, any>(
  [
    (state, props) => state['view-board'].cards[cardIdSelector(state, props)].statusId,
    (state, props) => state['view-board'].cardStatuses.byId,
  ],
  (
    statusId,
    cardStatusesById,
  ) => {
    if (!statusId) return null

    let cardStatus = cardStatusesById[statusId]

    if (cardStatus) {
      return cardStatus
    } else {
      // Default
      const ids = Object.keys(cardStatusesById)
      const length = ids.length
      for (let i = 0; i < length; i++) {
        cardStatus = cardStatusesById[ids[i]]
        if (cardStatus && cardStatus.isDefault) {
          return cardStatus
        }
      }
    }
  }
)

const createStatusSelector = (cardIdSelector) => {
  const cardStatusSelector = createCardStatusSelector(cardIdSelector)

  return createSelector<any, any, any, any>(
    [
      cardStatusSelector,
    ],
    (
      cardStatus,
    ) =>
      cardStatus
  )
}

export default createStatusSelector
